/**
 * Builds a legislation link href, choosing the scheme by host (https everywhere except localhost)
 * rather than trusting any scheme on the stored value.
 * @param {string} url bare legislation URL
 * @returns {string}
 */
export function legislationHref(url) {
    if (!url) return url
    const bare = url.replace(/^https?:\/\//i, "")
    const isLocal = /^(localhost|127\.0\.0\.1)([:/]|$)/i.test(bare)
    return `${isLocal ? "http" : "https"}://${bare}`
}
